// extracted by mini-css-extract-plugin
export default {"stickyTabs":"style_stickyTabs__YWjWM","textHeader":"style_textHeader__2sD0L","textBody":"style_textBody__U4Syb","notificationsDrawerBody":"style_notificationsDrawerBody__8ROOf"};